<template>
    <v-container grid-list-md fluid>
        <oss-dialog
            v-model="syncedExportGeneralLedgerDialog"
            :title="title"
            @previous="previous"
            :previous-display="!!exportWindowStep"
            @close="resetExportDialog()"
            :valid-title="exportWindowStep === 2 ? 'Valider' : 'Suivant'"
            :hide-valid="exportWindowStep !== 0 && exportWindowStep !== 1"
            :valid-disabled="
                !dateValid ||
                !GLOrBalance ||
                !GLOrBalance.length ||
                (fromExportAccounting && !exportThirdParty.length)
            "
            @valid="nextStepExportDialog()"
            prefixDataCy="GeneralLedgerExportDialog-valid"
            minWidth="40vw"
            maxWidth="50vw"
        >
            <v-window v-model="exportWindowStep">
                <v-window-item :key="0">
                    <v-form v-model="dateValid">
                        <oss-date-picker-filled
                            v-model="dateRange.start"
                            :filterWithoutClosedAccountingPeriods="false"
                            :mandatory="true"
                            label="Date de début d'export"
                            :textFieldReadOnly="false"
                            :minDate="mAccountingPeriodStart || mMaxStartDate || undefined"
                            :maxDate="mAccountingPeriodEnd || undefined"
                            class="mt-2"
                            data-cy="GeneralLedger2-startExportDate"
                        />
                        <oss-date-picker-filled
                            v-model="dateRange.end"
                            :filterWithoutClosedAccountingPeriods="false"
                            label="Date de fin d'export"
                            :mandatory="true"
                            :textFieldReadOnly="false"
                            :minDate="mAccountingPeriodStart || mMaxStartDate || undefined"
                            :maxDate="mAccountingPeriodEnd || undefined"
                            data-cy="GeneralLedger2-endExportDate"
                        />
                    </v-form>
                </v-window-item>
                <v-window-item :key="1">
                    <v-row no-gutters data-cy="GeneralLedger2-reconciliation">
                        <v-col cols="12" data-cy="GeneralLedger2-reconciliation">
                            <v-radio-group
                                v-model="reconciliation"
                                mandatory
                                inline
                                data-cy="GeneralLedger2-reconciliation"
                                color="primary"
                            >
                                <v-radio
                                    label="Toutes les écritures"
                                    value="all"
                                    data-cy="GeneralLedgerExportDialog-all"
                                />
                                <v-radio
                                    label="Uniquement les non lettrées"
                                    value="onlyNotReconciliated"
                                    data-cy="GeneralLedgerExportDialog-onlyNotReconciliated"
                                />
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" data-cy="GeneralLedgerExportDialog-grand-livre">
                            <v-checkbox
                                v-model="GLOrBalance"
                                label="Inclure le Grand Livre"
                                value="generalLedger"
                            />
                        </v-col>
                        <v-col cols="6" data-cy="GeneralLedgerExportDialog-balance">
                            <v-checkbox
                                v-model="GLOrBalance"
                                label="Inclure la Balance"
                                value="balance"
                            />
                        </v-col>
                    </v-row>
                    <v-divider v-if="fromExportAccounting === true" />
                    <v-row no-gutters v-if="fromExportAccounting === true">
                        <v-col cols="6">
                            <v-checkbox
                                v-model="exportThirdParty"
                                label="Comptes généraux"
                                :value="'general'"
                            />
                            <!-- <v-radio-group v-model="syncedThirdParty" mandatory inline>
                                    <v-radio label="Comptes généraux" :value="false"></v-radio>
                                    <v-radio label="Comptes tiers" :value="true"></v-radio>
                                </v-radio-group> -->
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox
                                v-model="exportThirdParty"
                                label="Comptes tiers"
                                :value="'thirdParty'"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item :key="2">
                    <v-row>
                        <v-checkbox
                            v-model="exportWithProjectWatermark"
                            :ripple="false"
                            class="ml-1 mb-2"
                            :title="$t('shared.exportWithProjectWatermark')"
                            :label="$t('shared.exportWithProjectWatermark')"
                        />
                    </v-row>
                    <v-list subheader lines="two">
                        <v-list-item
                            :class="
                                !$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item'
                                    : 'mb-2 px-2 oss-list-item'
                            "
                            @click="exportFile('XLSX')"
                            :disabled="exportWithProjectWatermark"
                            data-cy="GeneralLedgerExportDialog-excel"
                        >
                            <template #prepend>
                                <v-icon color="secondary"> $fa-file-excel </v-icon>
                            </template>

                            <v-list-item-title>Excel</v-list-item-title>
                            <!-- <v-list-item-subtitle>Ajoutez des recettes (ventes, z de caisse)</v-list-item-subtitle> -->

                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            :class="
                                !$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item rounded-lg'
                                    : 'mb-2 px-2 oss-list-item rounded-lg'
                            "
                            @click="exportFile('DOCX')"
                            data-cy="GeneralLedgerExportDialog-docs"
                        >
                            <template #prepend>
                                <v-icon color="secondary"> $fa-file-word </v-icon>
                            </template>
                            <v-list-item-title>Docx</v-list-item-title>
                            <!-- <v-list-item-subtitle>Ajoutez des dépenses (achats, notes de frais, ...)</v-list-item-subtitle> -->

                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            :class="
                                !$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item rounded-lg'
                                    : 'mb-2 px-2 oss-list-item rounded-lg'
                            "
                            @click="exportFile('PDF')"
                            data-cy="GeneralLedgerExportDialog-PDF"
                        >
                            <template #prepend>
                                <v-icon color="secondary"> $fa-file-pdf </v-icon>
                            </template>

                            <v-list-item-title>PDF</v-list-item-title>
                            <!-- <v-list-item-subtitle>Prenez une photo ou importez vos bulletins de salaires</v-list-item-subtitle> -->

                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-window-item>
                <!-- <v-window-item :key="3">
                        {{ accountingItemExport ? accountingItemExport.name : "" }}
                        <v-row no-gutters v-if="accountingItemExport">
                            <v-col cols="10" class="d-flex align-center">
                                <v-progress-linear
                                    color="secondary"
                                    height="10"
                                    rounded
                                    buffer-value="0"
                                    :value="100 * accountingItemExport.step / accountingItemExport.stepCount"
                                    stream
                                ></v-progress-linear>
                            </v-col>
                            <v-col cols="2" class="d-flex align-center justify-center">
                                <v-btn
                                    icon
                                    color="secondary"
                                    :disabled="!accountingItemExport.file"
                                    @click.stop="directDownload(); syncedExportDialog = false"
                                >
                                    <v-icon  size="small">$fa-cloud-download-alt</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-window-item> -->
            </v-window>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";

import AccountableAccountBalanceDetail from "./AccountableAccountBalanceDetail.vue";
import OssDataTable from "./ossComponents/ossDataTable2.vue";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";
import { formatDatePicker } from "../services/audit/AuditServices";

import EXPORT_GENERAL_LEDGER from "../graphql/accountingItem/ExportGeneralLedger.gql";

import getEnv from "../env";
import { NotificationBase } from "./NotificationBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        AccountableAccountBalanceDetail,
        OssDataTable,
    },
    emits: ["exportFileFinished"],
})
export class GeneralLedgerExportDialog extends NotificationBase {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) accountingPeriodId: string;
    @Prop({ default: false }) fromExportAccounting: boolean;
    @Prop({ default: null }) accountableAccountsSelected: Array<any>;
    @Prop({ default: "" }) inStartDate: string;
    @Prop({ default: "" }) inEndDate: string;
    @Prop({ default: null }) thirdParty: boolean;

    @Model({ type: Boolean, default: null, name: "exportGeneralLedgerDialog" })
    syncedExportGeneralLedgerDialog: boolean;

    miscellaneousOperationDialog: boolean = false;
    exportWindowStep: number = 0;
    GLOrBalance: Array<"generalLedger" | "balance"> = ["generalLedger"];
    exportThirdParty: Array<"general" | "thirdParty"> = [];
    reconciliation: "all" | "onlyNotReconciliated" = "all";

    dateValid: boolean = true;

    get title() {
        if (this.accountableAccountsSelected?.length) {
            return "Exporter l'extrait de compte";
        }
        return "Exporter tous les comptes";
    }

    get accountingPeriod() {
        return this.$store.state?.accountingPeriod?.selectedAccountingPeriod
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod
            : undefined;
    }

    get mAccountingPeriodStart() {
        const start = this.accountingPeriod?.start
            ? getDBFormattedStartDate(this.accountingPeriod.start)
            : undefined;
        // const start = this.accountingPeriod?.start ? moment(this.accountingPeriod.start).format("DD-MM-YYYY") : undefined
        // const start = this.accountingPeriod?.start ? moment(this.accountingPeriod.start).format() : undefined
        // debugger
        return start;
    }

    get mMaxStartDate() {
        const start = getDBFormattedStartDate(this.maxStartDate) || undefined;
        // const start = this.maxStartDate ? moment(this.maxStartDate).format("DD-MM-YYYY") : undefined
        // const start = moment(this.maxStartDate).format() || undefined
        return start;
    }

    get mAccountingPeriodEnd() {
        const end = this.accountingPeriod?.end
            ? getDBFormattedEndDate(this.accountingPeriod.end)
            : undefined;
        // const end = this.accountingPeriod?.end ? moment(this.accountingPeriod.end).format("DD-MM-YYYY") : undefined
        // const end = this.accountingPeriod?.end ? moment(this.accountingPeriod.end).format() : undefined
        return end;
    }

    dateRange = {
        start: "",
        end: "",
    };

    get maxStartDate() {
        const end = moment(this.dateRange.end);
        if (end.isValid()) {
            return end;
        }
        return this.accountingPeriod && this.accountingPeriod.end
            ? moment(this.accountingPeriod.end)
            : undefined;
    }

    get minEndDate() {
        const start = moment(this.dateRange.start);
        if (start.isValid()) {
            return start;
        }
        return this.accountingPeriod && this.accountingPeriod.start
            ? moment(this.accountingPeriod.start)
            : undefined;
    }

    formatDatePicker(date) {
        return this.formatDatePicker(date);
    }

    exportWithProjectWatermark = false;

    previous() {
        if (this.exportWindowStep !== 0) {
            this.exportWindowStep--;
        }
    }

    resetExportDialog() {
        // this.accountingItemExport = null
        this.exportWindowStep = 0;
        this.dateRange = {
            start: "",
            end: "",
        };
        this.removeListener();
    }

    nextStepExportDialog() {
        this.exportWindowStep++;
        // switch(this.exportWindowStep){
        //     case 0:
        //         this.exportWindowStep ++
        //         break
        //     case 1:
        //         this.exportWindowStep ++
        //         break
        //     case 2:
        //         this.exportWindowStep ++
        //         break
        // }
    }

    beforeMount() {
        if (this.inStartDate) {
            this.dateRange.start = formatDatePicker(this.inStartDate);
        } else if (this.accountingPeriod?.start) {
            this.dateRange.start = formatDatePicker(this.accountingPeriod.start) || "";
        } else {
            this.dateRange.start = formatDatePicker(moment().format());
        }
        //
        //
        //
        if (this.inEndDate) {
            this.dateRange.end = formatDatePicker(this.inEndDate);
        } else if (this.accountingPeriod?.end) {
            this.dateRange.end = formatDatePicker(this.accountingPeriod.end) || "";
        } else {
            this.dateRange.end = formatDatePicker(moment().format());
        }
        if (this.thirdParty) {
            this.exportThirdParty = ["thirdParty"];
        } else {
            this.exportThirdParty = ["general"];
        }
    }

    async exportFile(type) {
        const exportedFile = await this.$apollo.mutate({
            mutation: EXPORT_GENERAL_LEDGER,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                selectedAccountableAccounts: this.accountableAccountsSelected,
                exportThirdParty: this.exportThirdParty,
                dateRange: {
                    begin: getDBFormattedStartDate(this.dateRange.start),
                    end: getDBFormattedEndDate(this.dateRange.end),
                },
                exportType: type,
                GLOrBalance: this.GLOrBalance,
                onlyNotReconciliated: this.reconciliation === "onlyNotReconciliated" ? true : false,
                options: {
                    showPreviousBalance: this.fromExportAccounting ? undefined : false, // see 'https://trello.com/c/l04e9lY7' to understand why
                    watermark: this.exportWithProjectWatermark
                        ? this.$t("shared.draft").toUpperCase()
                        : undefined,
                },
            },
        });

        if (exportedFile.data.exportGeneralLedger) {
            if (this.fromExportAccounting) {
                this.GLOrBalance = ["generalLedger"];
                this.reconciliation = "all";
            }
            this.$emit("exportFileFinished");
            // this.syncedExportGeneralLedgerDialog = false
        }
    }
}

export default toNative(GeneralLedgerExportDialog);
</script>
